'use client';
import React from 'react';

import FooterBgLeft from '@/assets/icons/footerbg-left.svg';
import FooterBgRight from '@/assets/icons/footerbg-right.svg';

import { IMeetingPlaceLinkToAnyPage } from '../../../lib/fragments/meetingPlaceLinkToAnyPage';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import LinkWrapper from '../../link-wrapper/link-wrapper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

// export interface FooterProps {
//   contentfulMeetingPlacePageHome: ISliceComponentChinaFooterFragment;
// }

export const Footer = ({ data }: any) => {
  const meetingPlace = data?.meetingPlacePageHome?.meetingPlace;
  const footer = data?.meetingPlacePageHome?.footer;
  const copyRightText =
    '© Ingka Centres Holding B.V. ' + new Date().getFullYear();

  return (
    <>
      <footer
        className="relative mt-12 pb-8 text-neutral-grey-700 md:mt-auto md:pb-12 lg:mt-24"
        data-elastic-exclude
      >
        <div className="relative">
          <div className="grid h-44 grid-cols-12 xl:container xl:grid-flow-col">
            <div className=" col-start-2 col-end-11 flex md:col-start-2 md:col-end-4 md:flex-row">
              {meetingPlace?.logo && (
                <ImageWrapper
                  alt="Logotype"
                  url={meetingPlace?.logo?.url}
                  height={meetingPlace?.logo?.height}
                  width={140}
                  className="mb-10 max-h-10 w-36"
                  imgClassName="max-h-10 !w-auto"
                />
              )}
            </div>
            <div className="col-start-2 col-end-9 text-bodys md:col-start-4 md:col-end-6">
              <div className="border-t-[5px] border-solid border-accent-primary-normal pt-4 md:mt-8">
                {footer?.firstColumnContent &&
                  documentToReactComponents(footer?.firstColumnContent?.json)}
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 bg-transparent text-bodys xl:container sm:pb-20">
          <div className="col-start-2 col-end-12 flex flex-col md:col-start-4 md:flex-row">
            <div className="align-center order-2 mt-6 flex px-0 py-0 md:order-1 md:mt-0 md:pr-8">
              {copyRightText}
            </div>
            <ul
              className="order-1 mt-6 flex pt-4 sm:pt-0 md:order-2 md:mt-0"
              key={'menu-group-0'}
            >
              {footer?.linksCollection?.items
                ?.filter(Boolean)
                ?.map((page: any, index: number) => {
                  const isPageExternalLink =
                    page.__typename === 'LibraryChinaExternalLink';
                  const linkName = isPageExternalLink
                    ? page.linkTitle
                    : page.name;
                  return (
                    <li
                      key={`${linkName}-${index}`}
                      className="self-start pr-4 md:px-4"
                    >
                      <LinkWrapper
                        data={page as IMeetingPlaceLinkToAnyPage}
                        className="lg:hover:text-text-light lg:hover:underline"
                      >
                        {linkName}
                      </LinkWrapper>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
        <div className="h-30 pointer-events-none absolute bottom-0 left-0 -z-50 w-full sm:h-[31rem] md:overflow-hidden">
          <FooterBgLeft className="absolute -bottom-60 left-0 hidden w-44 overflow-hidden fill-accent-primary-normal md:block lg:w-[26rem]" />
          <FooterBgRight className="absolute -bottom-0 right-0 w-44 fill-accent-primary-normal lg:w-[20rem]" />
        </div>
      </footer>
    </>
  );
};

export default Footer;
